export const BRAND = {
  main: "National Karate Federation - NKF Bharat",
  sub: "राष्ट्रीय कराटे महासंघ (全米空手連盟)",
  mission: "Let's unite on one platform to promote karate sports in India",
  disciplines: "Traditional Karate | Semi Contact Karate | Full Contact Karate",
  slogan: ["जुड़ेगा भारत", "खेलेगा भारत", "जीतेगा भारत"],
  statement: "NKF – THE FUTURE OF INDIAN KARATE",
  logo: "/nkf-logo.jpg",
  contactPhones: ["+91 96547 12772", "+91 97737 24325"],
  contactEmail: "nkf.org.in@gmail.com",
  website: "nkf.org.in",
};

export const MEMBERSHIP_CATEGORIES = [
  {
    key: "independent_org",
    title: "Independent Organisation & Institutes",
    items: ["Independent Organisation", "School", "University"],
    icon: "Building2",
  },
  {
    key: "state",
    title: "State Affiliation",
    items: ["District Approval", "Technical Seminar", "Sports Science Conference"],
    icon: "MapPinned",
  },
  {
    key: "zonal_national",
    title: "Zonal / National",
    items: ["Traditional Karate", "Full Contact Karate", "Semi Contact Karate"],
    icon: "Flag",
  },
  {
    key: "corporate",
    title: "Corporate & Business",
    items: ["CSR", "Startup", "Sponsorship", "Partnerships"],
    icon: "Briefcase",
  },
  {
    key: "academy_club",
    title: "Academy & Club",
    items: ["Empowering India", "Athletes Technical Centers"],
    icon: "School",
  },
  {
    key: "active_youth",
    title: "Active Youth Card",
    items: ["Internship Projects", "Volunteers Registration"],
    icon: "Users",
  },
];

export const FOOTER_PORTALS = [
  { role: "coach", label: "Academy / Coach Login" },
  { role: "official", label: "Officials Login" },
  { role: "admin", label: "Admin Login" },
];

export const PRIMARY_NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/memberships", label: "Membership" },
  { to: "/affiliations", label: "Affiliation" },
  { to: "/championships", label: "Championships" },
  { to: "/recognitions", label: "Recognitions" },
  { to: "/zones", label: "Zones" },
  { to: "/certificates", label: "Certificates" },
  { to: "/downloads", label: "Downloads" },
  { to: "/media", label: "Media" },
  { to: "/contact", label: "Contact" },
];

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
  "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
  "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan",
  "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
  "Uttarakhand", "West Bengal", "Jammu & Kashmir", "Ladakh",
];
